import { TFunction } from "i18next";
import { MaterialRead } from "src/store/api/generatedApi";

export const getLabellingMaterialDisplayName = (
  material: MaterialRead | null,
  t: TFunction
): string => {
  return material?.labelling_name ?? t("unknown");
};

export const getRawMaterialDisplayName = (
  material: MaterialRead | null,
  t: TFunction
): string => {
  return material?.name ?? t("unknown");
};
